export default {"src":"/_next/static/media/mid-purple-right.2777a908.svg","height":280,"width":1920,"blurWidth":0,"blurHeight":0};